export default function EnergieErzeugerCheckboxes({ partner, handleCheckbox }) {
  return (
    <div style={{ marginTop: "20px" }}>
      <strong>Energieerzeuger</strong>

      {["E.ON", "RWE", "EnBW", "Vattenfall", "EWE", "Regional"].map((label) => (
        <div key={label}>
          <label>
            <input
              type="checkbox"
              value={label}
              onChange={handleCheckbox}
              checked={partner.energieErzeuger?.includes(label)}
            />
            &nbsp;{label === "Regional" ? "Beim regionalen EVU" : label}
          </label>
        </div>
      ))}
    </div>
  );
}